import React from "react";
import Field from "../../Common/Field/Field";
import App from "../../../pages/report/multiSelect";
import Picky from "react-picky"
import "react-picky/dist/picky.css" // Include CSS


const SampleReportByProcessesForm = props => {

    return (
        <div class="col-md-12 text-center " style={{ zIndex: "1001" }}>
            <div className="col-md-12 d-flex justify-content-center" style={{ zIndex: "1003" }}>
                <div className="col-md-2">
                    <label>Process Type <span className="text-danger">*</span></label>
                    <Picky
                        value={props.arrayValue}
                        options={props.processTypeOptions}
                        onChange={props.selectMultipleOption1}
                        open={false}
                        valueKey="value"
                        labelKey="label"
                        multiple={true}
                        includeSelectAll={true}
                        manySelectedPlaceholder={"%s selected"}
                        allSelectedPlaceholder={"%s selected"}
                        includeFilter={true}
                        dropdownHeight={300}
                        placeholder="No Items selected"
                        disabled={false}

                    />
                </div>
                <div className="col-md-2">
                    <label>Status</label>
                    <Field
                        inputType="select"
                        inputName="status"
                        value={props.status || "ALL"}
                        options={[{ value: "ALL", label: "All" }, ...props.statusOptions]}
                        onChange={props.updateState}
                        disabled={false}
                        className="Select-control"
                    />
                </div>
                <div className="col-md-2">
                    <label>Show only Headers <span className="text-danger">*</span></label>
                    <Picky
                        value={props.arrayValue1}
                        options={props.processTypeOptions}

                        onChange={props.selectMultipleOption}
                        open={false}
                        valueKey="value"
                        labelKey="label"
                        multiple={true}
                        includeSelectAll={true}
                        manySelectedPlaceholder={"%s selected"}
                        allSelectedPlaceholder={"%s selected"}
                        includeFilter={true}
                        dropdownHeight={300}
                        placeholder="No Items selected"
                        disabled={false}

                    />
                </div>
                <div className="col-md-2">
                    <label>Status</label>
                    <Field
                        inputType="select"
                        inputName="progress"
                        value={props.progress || 'ALL'}
                        options={props.progressOptions}
                        onChange={props.updateState}
                        disabled={false}
                        className="Select-control"
                    />
                </div>
            </div>
            <div className="col-md-12 d-flex justify-content-center p-1" style={{ zIndex: "1002" }}>
                <div className="col-md-2">

                    <label>Date From</label>
                    <Field
                        inputType="date"
                        inputName="fromDate"
                        label="from Date"
                        value={props.fromDate}
                        onChange={props.updateState}
                        disabled={false}
                        className="Select-control"
                    />
                </div>
                <div className="col-md-2" >
                    <label>Date To</label>
                    <Field
                        inputType="date"
                        inputName="toDate"
                        label="to Date"
                        value={props.toDate}
                        onChange={props.updateState}
                        disabled={false}
                        className="Select-control"
                    />
                    {/* </div> */}
                </div>
                <div className="col-md-2">
                    <label>Source of request</label>
                    <Field
                        inputType="select"
                        inputName="typeOfRequest"
                        value={props.typeOfRequest}
                        options={props.typeOfRequestOptions}
                        onChange={props.updateState}
                        disabled={false}
                        className="Select-control"

                    />
                </div>
                <div className="col-md-2">
                    <label>Sample Type</label>
                    {/* <Field
                        inputType="select"
                        inputName="sampleType"
                        value={props.sampleType}
                        options={props.sampleTypeOptions}
                        onChange={props.updateState}
                        disabled={false}
                        className="Select-control"
                    /> */}
                    <Picky
                        value={props.arrayValue2}
                        options={props.sampleTypeOptions}
                        onChange={props.selectMultipleOption2}
                        open={false}
                        valueKey="value"
                        labelKey="label"
                        multiple={true}
                        includeSelectAll={true}
                        manySelectedPlaceholder={"%s selected"} 
                        allSelectedPlaceholder={"%s selected"}
                        includeFilter={true} 
                        dropdownHeight={300}
                        placeholder="Select a sample type" 
                        disabled={false}
                    />
                </div>
            </div>
            <div className="col-md-12 d-flex justify-content-center p-1" style={{ zIndex: "1001" }}>
                <div className="col-md-3 p-2">
                    <label>Customer department</label>
                    <App
                        customerInfo={props.customerWithDepartment}
                        selectedCustomers={props.storeCustomerData}
                    />
                </div>
            </div>
            {/* <div className="col-md-12 d-flex justify-content-center">
                <div className="col-md-3 p-2" style={{ zIndex: "1001" }}>
                    <label>Customer department</label>
                    <App
                        customerInfo={props.customerWithDepartment}
                        selectedCustomers={props.storeCustomerData}
                    />
                </div>

                <div className="col-md-3">

                    <label>Date From</label>
                    <Field
                        inputType="date"
                        inputName="fromDate"
                        label="from Date"
                        value={props.fromDate}
                        onChange={props.updateState}
                        disabled={false}
                        className="Select-control"
                    />
                </div>
                <div className="col-md-3">
                    <label>Date To</label>
                    <Field
                        inputType="date"
                        inputName="toDate"
                        label="to Date"
                        value={props.toDate}
                        onChange={props.updateState}
                        disabled={false}
                        className="Select-control"
                    />
                    
                </div>
                <div className="col-md-3">
                    <label>Status</label>
                    <Field
                        inputType="select"
                        inputName="status"
                        value={props.status || "PENDING"}
                        options={props.statusOptions}
                        onChange={props.updateState}
                        disabled={false}
                        className="Select-control"

                    />
                </div>
            </div>
            <div className="col-md-12 d-flex justify-content-center p-1">
                <div className="col-md-3" style={{ zIndex: "1000" }}>
                    <label>Process Type</label>
                    <Picky
                        value={props.arrayValue}
                        options={props.processTypeOptions}

                        onChange={props.selectMultipleOption1}
                        open={false}
                        valueKey="value"
                        labelKey="label"
                        multiple={true}
                        includeSelectAll={true}
                        manySelectedPlaceholder={"%s selected"}
                        allSelectedPlaceholder={"%s selected"}
                        includeFilter={true}
                        dropdownHeight={300}
                        placeholder="No Items selected"
                        disabled={false}

                    />
                </div>
                <div className="col-md-3">
                    <label>Show only Headers</label>
                    <Picky
                        value={props.arrayValue1}
                        options={props.processTypeOptions}

                        onChange={props.selectMultipleOption}
                        open={false}
                        valueKey="value"
                        labelKey="label"
                        multiple={true}
                        includeSelectAll={true}
                        manySelectedPlaceholder={"%s selected"}
                        allSelectedPlaceholder={"%s selected"}
                        includeFilter={true}
                        dropdownHeight={300}
                        placeholder="No Items selected"
                        disabled={false}

                    />
                </div>
                <div className="col-md-3">
                    <label>Source of request</label>
                    <Field
                        inputType="select"
                        inputName="typeOfRequest"
                        value={props.typeOfRequest}
                        options={props.typeOfRequestOptions}
                        onChange={props.updateState}
                        disabled={false}
                        className="Select-control"

                    />
                </div>
                <div className="col-md-3">
                    <label>Sample Type</label>
                    <Field
                        inputType="select"
                        inputName="sampleType"
                        value={props.sampleType}
                        options={props.sampleTypeOptions}
                        onChange={props.updateState}
                        disabled={false}
                        className="Select-control"
                    />
                </div>
            </div>
         */}
        </div>
    );
};

export default SampleReportByProcessesForm;


// WEBPACK FOOTER //
// ./src/components/Report/forms/SampleReportByProcesses.js